import { React } from 'react';
import Modal from 'react-bootstrap/Modal';

const SuccessModal = ({
    showSuccessModal,
    hideSuccessModal,
    successMessage,
    onConfirm,
}) => {
    return (
        <Modal
            show={showSuccessModal}
            onHide={hideSuccessModal}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className='w-100 text-center p-2'>
                    Update Success!
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-column justify-content-center align-items-center p-3'>
                    <p className="text-center mb-2">{successMessage}</p>
                </div>
            </Modal.Body>
            <Modal.Footer className='ps-4 pe-4'>
                <div className='d-flex justify-content-end w-100'>
                    <button
                        className='upates-close py-2 px-3'
                        onClick={onConfirm}>OK</button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export { SuccessModal };
